import { createFileRoute } from '@tanstack/react-router';
import { SuppliersPage } from '@/features/finance';

export const Route = createFileRoute('/_auth/o/$orgId/finance/suppliers')({
  component: SuppliersRoute,
});

function SuppliersRoute() {
  const { orgId } = Route.useParams();
  return <SuppliersPage orgId={orgId} />;
}
